// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./turbo_confirm"
import "./controllers"
import "./controllers/component_controllers"
import Alpine from "@alpinejs/csp"

Alpine.data("copyButton", () => ({
  copied: false,
  value: "",
  label: "Copy",

  init() {
    this.value = this.$el.dataset.value || ""
    this.label = this.$el.dataset.label || "Copy"
  },

  copy() {
    navigator.clipboard.writeText(this.value).then(() => {
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 1500)
    })
  },

  get displayLabel() {
    return this.copied ? "Copied!" : this.label
  },

  get copiedClass() {
    return this.copied ? "text-green-600 font-medium" : ""
  }
}))

Alpine.data("copyGroup", () => ({
  copied: false,
  value: "",

  init() {
    this.value = this.$root.dataset.value || ""
  },

  copy() {
    navigator.clipboard.writeText(this.value).then(() => {
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 2000)
    })
  },

  get displayLabel() {
    return this.copied ? "Copied!" : "Copy"
  },

  selectInput() {
    this.$refs.input.select()
  }
}))

Alpine.data("celebration", () => ({
  open: true,
  duration: 1800,

  init() {
    this.duration = Number(this.$root.dataset.duration || 1800)
    setTimeout(() => {
      this.open = false
    }, this.duration)
    setTimeout(() => {
      this.$root.remove()
    }, this.duration + 500)
  }
}))

Alpine.data("goalForm", () => ({
  name: "",
  why: "",

  init() {
    this.name = this.$root.dataset.name || ""
    this.why = this.$root.dataset.why || ""
  },

  get northStarText() {
    return this.name || "Your North Star"
  }
}))

Alpine.data("projectForm", () => ({
  name: "",
  goal: "",
  deadline: "",

  init() {
    this.name = this.$root.dataset.name || ""
    this.goal = this.$root.dataset.goal || ""
    this.deadline = this.$root.dataset.deadline || ""
  },

  get projectNameText() {
    return this.name || "Your project"
  },

  get goalText() {
    return this.goal || "Define an outcome that moves the star."
  },

  get dueText() {
    return this.deadline ? `Due: ${this.deadline}` : ""
  },

  get hasDeadline() {
    return this.deadline !== ""
  }
}))

Alpine.data("welcomeDemo", () => ({
  sorted: false,

  init() {
    setTimeout(() => {
      this.sorted = true
    }, 250)
  },

  get pileClass() {
    return this.sorted ? "opacity-0 scale-75 h-0" : "opacity-100"
  }
}))

window.Alpine = Alpine
Alpine.start()
